import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "../redux/actions/Index";
import TourCreationPage from "../components/pages/tourCreation/TourCreationPage";

export const mapStateToProps = (state: any, props: any) => {
  return {
    warehouseList: state.product.wareHouseNames,
    deliveryOptions: state.productCityLevel.deliveryOptions,
    isSubmitted: state.shipper.isSubmitted,
    isLoading: state.shipper.isLoading,
    isError: state.shipper.isError,
    error: state.shipper.error,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    getWarehouses: () => dispatch(actions.fetchWareHouseNames()),
    getDeliveryOptions: () => dispatch(actions.fetchDeliveryOptions()),
    upload3plTourCsv: (payload: FormData, url: string) =>
      dispatch(actions.upload3plTourCsv(payload, url)),
  };
};

const TourCreationContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TourCreationPage);
export default TourCreationContainer;
